import {
  PartnerTransferSection,
  PartnerTransferTypes,
} from 'further-types/lp/partner-transfer';

export const PartnerTransferSectionLabels = {
  [PartnerTransferSection.PartnerTransfer]: 'Partner Transfer',
  [PartnerTransferSection.Investments]: 'Investments',
  [PartnerTransferSection.Expenses]: 'Expenses',
  [PartnerTransferSection.Income]: 'Income',
  [PartnerTransferSection.Fees]: 'Fees',
  [PartnerTransferSection.LinkedCapitalActions]: 'Linked Capital Actions',
  [PartnerTransferSection.GeneralCapitalActions]: 'General Capital Actions',
  [PartnerTransferSection.Summary]: 'Summary',
};

export const PartnerTransferTypeLabels = {
  [PartnerTransferTypes.PartnerTransfer]: 'Capital Action (Partner Transfer)',
};
